/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-one-expression-per-line, no-restricted-syntax, no-return-assign, no-nested-ternary, no-param-reassign, no-confusing-arrow */
import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  lazy,
  Suspense,
} from 'react';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Material
import TableCell from '@material-ui/core/TableCell';
import Box from '@material-ui/core/Box';
import Tr from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

// Material Icons
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import InfoSharpIcon from '@material-ui/icons/InfoSharp';

// Date FNS
import format from 'date-fns/format';

// Lodash
import { groupBy } from 'lodash';

// Actions
import { setSecondOpen } from 'store/ducks/dialogs/actions';

// Helpers
import { currencyFormat } from 'helpers/currencyFormat';
import { difference } from 'helpers/diffTimes';

// Types
import { TripReportInterface } from 'store/ducks/trips/types';
import { ApplicationState } from 'store';

// Constants
import { CONST_LINES_OBJECT } from 'constants/lines';

// Components
import SubRow from '../SubRow/SubRow';
import { InfoDrawer } from '../InfoDrawer';
import { PrettiNameLine } from 'components/ReportComponents';

// Icons
import { Warning } from 'icons/Symbols_Warning_Safety';

// Styles
import useStyles from './tableRow.styles';

// Lazy Componenents

const TripReportDialog = lazy(() =>
  import('components/TripReportDialog/TripReportDialog'),
);

interface TableRowInterface {
  tripReport: TripReportInterface[];
  index: number;
  driverName: string;
  openCollapseAll: boolean;
  isAgrouped: boolean;
}

type Props = TableRowInterface;

const TableRow: React.FC<Props> = ({
  tripReport,
  index,
  driverName,
  openCollapseAll,
  isAgrouped,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const classRow = index % 2 === 0 ? classes.evenRow : classes.oddRow;

  const [benefitsList, setBenefitsList] = useState<string[]>([]);
  const [openCollapse, setOpenCollapse] = useState(false);
  const [collapseTrips, setCollapseTrips] = useState<
    Array<Array<TripReportInterface[] | string>>
  >([]);
  const [infoDrawerState, setInfoDrawerState] = useState<{
    data: TripReportInterface | any;
    open: boolean;
  }>({
    data: null,
    open: false,
  });

  const kmType = useSelector((state: ApplicationState) => state.trips.kmType);

  useEffect(() => {
    setBenefitsList(() => {
      const benefitsList: string[] = [];
      if (Array.isArray(tripReport) && tripReport.length > 0) {
        for (const trip of tripReport) {
          const benefits = trip.EntriesResume?.entries?.benefits;
          if (benefits) {
            for (const benefit of Object.keys(benefits)) {
              if (!benefitsList.includes(benefit)) {
                benefitsList.push(benefit);
              }
            }
          }
        }
      }
      return benefitsList;
    });
  }, [tripReport]);

  useEffect(() => {
    setInfoDrawerState({
      data: null,
      open: false,
    });
  }, []);

  const toggleInfoDrawer = useCallback(
    (open: boolean, data?: any) => (event: any) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return;
      }

      if (!data && infoDrawerState.open) {
        setInfoDrawerState({
          data: null,
          open: false,
        });

        return;
      }

      setInfoDrawerState({
        data,
        open,
      });
    },
    [infoDrawerState],
  );

  const totalKm = useMemo(
    () => (km: number, idleKm: number) => (km + idleKm).toFixed(2),
    [],
  );

  const renderBenefitValue = useMemo(
    () => (trip: TripReportInterface, benefit: string) => {
      if (trip.EntriesResume?.entries?.benefits) {
        const { benefits } = trip.EntriesResume.entries;
        return benefits.hasOwnProperty(benefit)
          ? // @ts-ignore
            Number(benefits[benefit].quantity)
            ? // @ts-ignore
              benefits[benefit].quantity
            : 0
          : // @ts-ignore
            (benefits[benefit] = 0);
      }
      return 0;
    },
    [],
  );
  const isEqual = (tripData: TripReportInterface) => {
    if (tripData && tripData?.EntriesResume) {
      return tripData.totalPassengers === tripData.EntriesResume.quantity;
    } else {
      return false;
    }
  };
  useEffect(() => {
    setOpenCollapse(openCollapseAll);
  }, [openCollapseAll]);

  useEffect(() => {
    let aux: any = {};
    tripReport.forEach((trip) => {
      if (!trip?.parentId) {
        aux[trip.id] = [];
        aux[trip.id].push(trip);
      }
    });
    Object.entries(aux).forEach(([key, _]) => {
      tripReport.forEach((trip) => {
        if (trip?.parentId) {
          if (key === trip.parentId) aux[key].push(trip);
        }
      });
    });
    setCollapseTrips(
      Object.entries(aux) as Array<Array<TripReportInterface[] | string>>,
    );
  }, [tripReport]);

  return (
    <>
      <InfoDrawer
        open={infoDrawerState.open}
        data={infoDrawerState.data}
        toggleDrawer={toggleInfoDrawer}
      />
      <>
        <Tr className={classRow}>
          <TableCell>
            <Box
              display='flex'
              alignItems='center'
              justifyContent='space-between'>
              <Box display='flex' alignItems='center'>
                <IconButton
                  aria-label='expand row'
                  size='small'
                  onClick={() => setOpenCollapse((o) => !o)}>
                  {openCollapse ? (
                    <KeyboardArrowUpIcon />
                  ) : (
                    <KeyboardArrowDownIcon />
                  )}
                </IconButton>
              </Box>
              <Typography className={classes.driverName}>
                {driverName}
              </Typography>
            </Box>
          </TableCell>
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          <TableCell />
          {Array.isArray(benefitsList) &&
            benefitsList.map((benefit) => <TableCell />)}
          <TableCell></TableCell>
        </Tr>

        {isAgrouped ? (
          <>
            {openCollapse &&
              collapseTrips.length > 0 &&
              collapseTrips.map(([key, value]) => (
                <SubRow
                  toggleInfoDrawer={toggleInfoDrawer}
                  collapseTrips={value as TripReportInterface[]}
                  index={index}
                />
              ))}
          </>
        ) : (
          <>
            {openCollapse &&
              tripReport.length > 0 &&
              Object.entries(
                groupBy(
                  tripReport.sort((a: any, b: any) => {
                    if (a?.LineSection && b?.LineSection) {
                      return a?.LineSection?.Line?.name.localeCompare(
                        b?.LineSection?.Line?.name,
                      );
                    }
                  }),
                  (item) => item.LineSection?.Line?.name,
                ),
              ).map(([key, trip]: any) =>
                trip.map((item: any) => {
                  const resume = item?.resume ? JSON.parse(item?.resume) : null;

                  return (
                    <Tr key={item.id} className={classRow}>
                      <TableCell />
                      <TableCell>
                        {' '}
                        <PrettiNameLine
                          line={`${trip[0].LineSection?.Line?.prefix} - ${key}`}
                          color={trip[0].LineSection?.Line?.color || '#9427EA'}
                        />
                      </TableCell>
                      <TableCell align='center'>
                        {item?.LineSection?.way === 0
                          ? CONST_LINES_OBJECT.WAYS.GO.VALUE
                          : CONST_LINES_OBJECT.WAYS.BACK.VALUE}
                      </TableCell>
                      <TableCell align='center'>
                        {item?.id?.slice(0, 8) || '--'}
                      </TableCell>
                      <TableCell align='center'>
                        {item?.Car?.prefix || '--'}
                      </TableCell>
                      <TableCell align='center'>
                        {item.startedAt
                          ? format(new Date(item.startedAt), 'dd/MM/yyyy')
                          : '--'}
                      </TableCell>
                      <TableCell align='center'>
                        {item.startedAt
                          ? format(new Date(item.startedAt), 'HH:mm:ss')
                          : '--'}
                      </TableCell>
                      <TableCell align='center'>
                        {item?.closedAt
                          ? format(
                              new Date(item.closedAt),
                              item.startedAt &&
                                format(new Date(item.startedAt), 'dd/MM/yyyy') !==
                                  format(new Date(item.closedAt), 'dd/MM/yyyy')
                                ? 'dd/MM/yyyy HH:mm:ss'
                                : 'HH:mm:ss',
                            )
                          : '--'}
                      </TableCell>
                      <TableCell align='center'>
                        {item?.closedAt && item.startedAt
                          ? difference(item.closedAt, item.startedAt)
                          : '--'}
                      </TableCell>
                      <TableCell align='center'>
                        {kmType === 'total'
                          ? totalKm(item.km, item.idleKm)
                          : item.km?.toFixed(2)}
                      </TableCell>
                      {kmType === 'discriminated' && (
                        <TableCell align='center'>
                          {item.idleKm?.toFixed(2)}
                        </TableCell>
                      )}
                      <TableCell align='center'>
                        {currencyFormat({ value: item.valuePerKm || 0 })}
                      </TableCell>
                      <TableCell align='center'>
                        {item.ipk?.toFixed(2) || '0.00'}
                      </TableCell>
                      <TableCell align='center'>
                        {item.ipke?.toFixed(2) || '0.00'}
                      </TableCell>
                      <TableCell align='center'>
                        {item?.EntriesResume?.quantity || '0'}
                      </TableCell>
                      <TableCell align='center'>
                        {item?.totalPassengers || '0'}
                      </TableCell>
                      <TableCell align='center'>
                        {resume
                          ? currencyFormat({ value: resume?.totalValue || 0 })
                          : '0'}
                      </TableCell>
                      {Array.isArray(benefitsList) &&
                        benefitsList.map((benefit) => (
                          <TableCell key={benefit} align='center'>
                            {renderBenefitValue(item, benefit)}
                          </TableCell>
                        ))}
                      <TableCell align='right'>
                        <Box display='flex' alignItems='center'>
                          <Tooltip
                            placement='top'
                            title='Informações da viagem'>
                            <IconButton
                              onClick={() => {
                                dispatch(
                                  setSecondOpen({
                                    open: true,
                                    maxWidth: 'xl',
                                    content: (
                                      <Suspense fallback={<p>Carregando...</p>}>
                                        <TripReportDialog
                                          tripId={item?.id ? item?.id : ''}
                                        />
                                      </Suspense>
                                    ),
                                  }),
                                );
                              }}>
                              <InfoSharpIcon />
                            </IconButton>
                          </Tooltip>
                          {!isEqual(item) && (
                            <Tooltip
                              placement='top'
                              title='Existe diferença na quantidade de viagem'>
                              <IconButton>
                                <Warning fill='#EA9427' />
                              </IconButton>
                            </Tooltip>
                          )}{' '}
                        </Box>
                      </TableCell>
                    </Tr>
                  );
                }),
              )}
          </>
        )}
      </>
    </>
  );
};
export { TableRow };
export default TableRow;
